import { Store } from 'vuex';
import * as ErrorStore from '@/store/modules/error';

export function initOnFullFilled<T>(
  store: Store<T>,
  callback: Function = () => {}
) {
  return response => {
    callback(response);

    // @ts-ignore
    const $vm = store._vm;

    if ($vm?.$Progress) $vm.$Progress.finish();

    return response;
  };
}

export function initOnRejected<T>(
  store: Store<T>,
  callback: Function = () => {}
) {
  return response => {
    callback();

    // @ts-ignore
    const $vm = store._vm;

    if ($vm.$Progress) $vm.$Progress.fail();

    try {
      // reload to redirect to login page
      if (
        [
          401, // Unauthenticated error
          404, // Invalid Authentication Token (by protect_from_forgery :null_session)
        ].includes(response?.response?.status)
      ) {
        const msg = 'セッションが無効です。再度ログインしてください';
        if (confirm(msg)) {
          location.reload();
        }
        return Promise.reject(response);
      }

      const errorMessages =
        response.response?.data?.data?.attributes?.error_messages;
      if (errorMessages) {
        store.dispatch(
          ErrorStore.SetErrors(errorMessages, {
            namespace: ErrorStore.namespace,
          })
        );
      } else {
        $vm.$notifyError(
          '予期せぬエラーが発生しました。管理者にお問い合わせください。'
        );
      }
    } catch (e) {
      $vm.$notifyError(
        '予期せぬエラーが発生しました。管理者にお問い合わせください。'
      );
    }
    return Promise.reject(response);
  };
}
